
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateAttemptSelection } from "./AnswerEvaluateEngine";
const NATInputTyper = ({question,attempt, setAttempt,element,icon,alt,title}) =>{

    
       const dispatch = useDispatch();
       
    
const [inputValue, setInputValue] =useState(attempt?.userAnswer?attempt?.userAnswer:"")
useEffect(()=>{
  // setAttempt(updateAttemptSelection(question, attempt, element?.ID,null, inputValue));

},[inputValue])
const funcCalc=(val,type)=>{
    if(type=="add"){
        setInputValue(inputValue+val)
        setAttempt(updateAttemptSelection(question, attempt, element?.ID,null,inputValue+val));
    }
    if(type=="backspace"){
        setInputValue(inputValue?.slice(0, -1))
          setAttempt(updateAttemptSelection(question, attempt, element?.ID,null,inputValue?.slice(0, -1)));
    } if(type=="clearall"){
        setInputValue("")
         setAttempt(updateAttemptSelection(question, attempt, element?.ID,null,""));
    }
    
    if(type=="dot"){
        if (!(inputValue?.includes('.'))) {
            setInputValue(inputValue+'.')
             setAttempt(updateAttemptSelection(question, attempt, element?.ID,null,inputValue+'.'));
  
}
    }

    if(type=="sign"){
        if ((!inputValue?.includes('-'))) {
            setInputValue('-'+inputValue)
              setAttempt(updateAttemptSelection(question, attempt, element?.ID,null,'-'+inputValue));
  
  
}else{
     setInputValue(inputValue?.slice(1))
       setAttempt(updateAttemptSelection(question, attempt, element?.ID,null,inputValue?.slice(1)));
  
}
    
    
}
    
}

return(<> 
<div style={{width:"103px",marginTop:"10px"}} ><input className=""  disabled style= {{fontSize:"15px" ,marginBottom:"10px",border:"1px solid #999", borderRadius:"2px",width:"120px",margin:"0px",padding:"7px 9px"}} placeholder={`Correct Answer`} type="text"
   name="optionText" value={inputValue} onChange={(e)=>{
  
  }} />
  <div style={{display:"grid",gridTemplateColumns:"100%"}} >
    
     <div 
      
      onClick={()=>funcCalc("","backspace")}
      className="calcInputBtnNum" >Backspace</div>
     </div>
      <div style={{display:"grid",gridTemplateColumns:"33% 33% 33%"}} >
     <div 
     
     onClick={()=>funcCalc("9","add")}
     className="calcInputBtnNum" >9</div>
      <div 
      
      onClick={()=>funcCalc("8","add")}
     className="calcInputBtnNum">8</div>
      <div 
     
      onClick={()=>funcCalc("7","add")}
       className="calcInputBtnNum">7</div>
        </div>  <div style={{display:"grid",gridTemplateColumns:"33% 33% 33%"}} >
     <div 
      
     onClick={()=>funcCalc("6","add")}
      className="calcInputBtnNum" >6</div>
      <div 
     
      onClick={()=>funcCalc("5","add")}
       className="calcInputBtnNum">5</div>
      <div 
     
      onClick={()=>funcCalc("4","add")}
        className="calcInputBtnNum">4</div>
        </div>  <div style={{display:"grid",gridTemplateColumns:"33% 33% 33%"}} >
     <div 
     
      onClick={()=>funcCalc("3","add")}
      className="calcInputBtnNum" >3</div>
      <div 
     
      onClick={()=>funcCalc("2","add")}
       className="calcInputBtnNum">2</div>
      <div 
      
      onClick={()=>funcCalc("1","add")}
      className="calcInputBtnNum">1</div>
        </div>    <div style={{display:"grid",gridTemplateColumns:"33% 33% 33%"}} >
     <div 
     
      onClick={()=>funcCalc("0","add")}
      className="calcInputBtnNum" >0</div>
      <div 
     
     onClick={()=>funcCalc("","dot")}
      className="calcInputBtnNum">.</div>
      <div 
     
      onClick={()=>funcCalc("","sign")}
      className="calcInputBtnNum">- +</div>
        </div>    
      <div style={{display:"grid",gridTemplateColumns:"100%"}} >
     <div 
     
     onClick={()=>funcCalc("","clearall")}
     className="calcInputBtnNum" >Clear All</div>
     </div>
        </div>


</>)
}
export default NATInputTyper;